<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="section">
        <div class="columns is-vcentered">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <div class="has-text-centered has-margin-bottom-30">
                <h2 class="title">Finalize Your Team Entry</h2>
              </div>
              <div
                class="columns is-multiline has-padding-15"
                style="background: #eee; border-radius: 3px"
                v-if="evententry && evententry.user"
              >
                <div class="column is-6-desktop">
                  <strong>Your Team Name:</strong><br />{{
                    evententry.teamname
                  }}
                </div>
                <div class="column is-6-desktop">
                  <strong>Your Captain:</strong><br />
                  {{ evententry.user.firstname }} {{ evententry.user.surname }}
                </div>
              </div>
              <ValidationObserver v-slot="{ passes }">
                <form @submit.prevent="passes(submit)">
                  <div
                    class="columns"
                    v-if="event.config && event.config.allowdependants"
                  >
                    <div class="column">
                      <div class="control">
                        <DependantSelect
                          v-model="entry.dependant"
                          @input="changeDependant"
                        />
                      </div>
                    </div>
                    <div class="column">
                      <div class="control">
                        <b-field>
                          <router-link
                            class="button is-primary primary-btn has-text-white m-t-lg"
                            :to="{ name: 'ManageDependants' }"
                            >Manage Dependants</router-link
                          >
                        </b-field>
                      </div>
                    </div>
                  </div>
                  <div class="columns is-multiline">
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.showidno"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="South African ID No/Passport"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="South African ID No/Passport"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.idno" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.showcontactno"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Mobile Number"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Mobile Number"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.contactno" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.showshirttype"
                    >
                      <div class="control">
                        <BaseSelect
                          label="Shirt Type"
                          v-model="entry.meta.shirttype"
                          rules="required"
                        >
                          <option
                            v-for="shirttype in shirttypes"
                            :key="shirttype"
                          >
                            {{ shirttype }}
                          </option>
                        </BaseSelect>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && !event.config.hideshirtoption"
                    >
                      <div class="control">
                        <SizeSelect
                          label="Shirt Size"
                          rules="required"
                          v-model="entry.tshirtsize"
                        />
                      </div>
                    </div>

                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.showshortsize"
                    >
                      <div class="control">
                        <SizeSelect
                          label="Shorts Size"
                          v-model="entry.pantssize"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <ValidationProvider
                          name="Emergency Contact Name"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Emergency Contact Name"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.emergencycontactname" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <ValidationProvider
                          name="Emergency Contact Number"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Emergency Contact Number"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.emergencycontactno" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div
                      class="column"
                      v-if="event.config && !event.config.hidelegal"
                    >
                      <div
                        v-if="event.legalcontent"
                        v-html="event.legalcontent"
                      ></div>
                      <ValidationProvider
                        name="Accept event's terms and conditions"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-field
                          :type="{ 'is-danger': errors.length > 0 }"
                          :message="errors[0]"
                          class="m-t-sm"
                        >
                          <b-checkbox v-model="entry.terms">
                            Accept event's terms and conditions
                          </b-checkbox>
                        </b-field>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="has-text-centered">
                    <div class="is-block has-text-centered">
                      <button
                        class="button btn-align no-lh raised is-medium primary-btn"
                        type="submit"
                        :disabled="saving"
                        :class="{ 'is-loading': saving }"
                      >
                        Finalize Entry
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DependantSelect from "@/components/DependantSelect";
import BaseSelect from "@/components/BaseSelect";
import SizeSelect from "@/components/SizeSelect";
import EventEntryApi from "@/api/event-entry";
import TeamMemberApi from "@/api/team-member";
export default {
  components: {
    DependantSelect,
    SizeSelect,
    BaseSelect,
  },
  data() {
    return {
      loading: true,
      search: {
        by: "teamname",
      },
      event: {},
      evententry: {},
      entry: {
        meta: {},
      },
      saving: false,
      currentUser: {},
      shirttypes: [],
    };
  },
  computed: {
    ...mapGetters(["user", "dependants"]),
    selectedDependant() {
      if (this.entry.dependant) {
        return this.dependants.filter(
          (dependant) => dependant._id === this.entry.dependant
        );
      }
    },
  },
  async created() {
    this.entry = await TeamMemberApi.showEntryByEvent(this.$route.params.id);
    if (this.entry) {
      if (!this.entry.meta) {
        this.entry.meta = {};
      }
      this.event = this.entry.event;
    }

    this.evententry = EventEntryApi.getEventEntry(this.entry.evententry);
    this.currentUser = await this.getFullUser();
    if (!this.entry.emergencycontactname) {
      this.entry.emergencycontactname = this.currentUser.emergencycontactname;
    }
    if (!this.entry.emergencycontactno) {
      this.entry.emergencycontactno = this.currentUser.emergencycontactno;
    }
    if (!this.entry.tshirtsize) {
      this.entry.tshirtsize = this.currentUser.tshirtsize;
    }
    if (this.event.config && this.event.config.showshirttype) {
      this.shirttypes = this.event.config.shirttypes[this.currentUser.gender];
    }

    this.loading = false;
  },
  methods: {
    ...mapActions(["getFullUser", "updateUser", "getUser"]),
    changeDependant() {
      if (this.entry.dependant) {
        const dependant = this.dependants.find(
          (item) => item._id == this.entry.dependant
        );
        if (dependant) {
          this.entry.gymname = dependant.gymname;
        }
      } else {
        this.entry.gymname = this.currentUser.gymname;
      }
    },
    async submit() {
      this.saving = true;
      try {
        this.entry.evententry = this.evententry._id;
        this.entry.dateaccepted = new Date();
        this.entry.acceptwaiver = true;
        this.entry.user = this.currentUser._id;
        this.entry.event = this.event._id;
        this.entry.firstname = this.entry.dependant
          ? this.selectedDependant.firstname
          : this.currentUser.firstname;
        this.entry.surname = this.entry.dependant
          ? this.selectedDependant.surname
          : this.currentUser.surname;
        this.entry.gender = this.entry.dependant
          ? this.selectedDependant.gender
          : this.currentUser.gender;

        if (!this.entry.dependant) {
          let fields = [
            "country",
            "tshirtsize",
            "pantssize",
            "gymname",
            "emergencycontactno",
            "emergencycontactname",
            "idno",
            "contactno",
          ];
          let updateUser = false;
          fields.forEach((field) => {
            if (!updateUser && this.entry[field] !== this.user[field]) {
              this.currentUser[field] = this.entry[field];
              updateUser = true;
            }
          });
          if (updateUser) {
            await this.updateUser(this.currentUser);
          }
        }

        await TeamMemberApi.updateEntry(this.entry);
        this.saving = false;
        this.$buefy.toast.open({
          message: "You've finalized your entry successfully.",
          position: "is-top",
          type: "is-success",
        });
        this.$router.push({ name: "Home" });
      } catch (error) {
        this.saving = false;
        this.$buefy.toast.open({
          message: "Error finalizing your entry.",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>


<style>
p {
  margin-bottom: 15px;
}
</style>